
import { Vue, Component,Prop } from "vue-property-decorator";
import FaceTempleteDetail from "./components/face-templete-detail.vue";
import FaceTempleteClass from "./components/face-templete-class.vue";

import ParentDetail from "./components/parent-detail.vue";
import { faceTempleteService } from '@/api/payments/faceTempleteService';
import { FaceTempletePaidDetailDto } from '@/api/service-proxies';

@Component({
  components: {
    FaceTempleteDetail,
    FaceTempleteClass,
    ParentDetail,
  },
})
export default class PaymentDetail extends Vue {

faceTempleteId!:number;
faceTempletePaidDetailDto:FaceTempletePaidDetailDto=null;

created(){
  this.faceTempleteId=<number><unknown>this.$route.params["id"];

  this.getData();
}

  getData() {
    faceTempleteService
      .getFaceTempletePaidDetail(this.faceTempleteId)
      .then((result) => {
        this.faceTempletePaidDetailDto = result;
      
      });
  }


}
